/**
 * Beta-trial gate constants + helpers.
 *
 * MAVK is on a single-user beta of the warehouse PWA. The trial runs
 * up to and INCLUDING 8 June 2026 IST; from midnight IST on 9 June
 * 2026 onwards an active subscription is required.
 *
 * Encoded as a fixed UTC moment so the gate behaves identically
 * regardless of what timezone the device is configured for. India
 * Standard Time is UTC+5:30 → 2026-06-09T00:00 IST = 2026-06-08T18:30Z.
 *
 * NOTE: this is a client-side gate only. A determined operator can
 * bypass by rolling their device clock backward. The companion
 * server-side enforcement should be added in the subscriptions /
 * tenant feature-flag layer before commercial GA — until then the
 * banner + this FE gate carry the contract.
 */

export const TRIAL_TENANT_NAME = 'MAVK';
export const TRIAL_END_ISO = '2026-06-08T18:30:00.000Z'; // 9 Jun 2026 00:00 IST
export const TRIAL_END_DATE = new Date(TRIAL_END_ISO);
/** Display string used in every customer-facing surface (banner, profile, expiry). */
export const TRIAL_END_LABEL = '8 June 2026';
export const TRIAL_RENEWAL_LABEL = '9 June 2026';

export interface TrialStatus {
  /** Has the trial passed its end date? */
  expired: boolean;
  /** Whole days remaining (0 once we're on the final day; -1 once expired). */
  daysRemaining: number;
}

export function getTrialStatus(now: Date = new Date()): TrialStatus {
  const msRemaining = TRIAL_END_DATE.getTime() - now.getTime();
  if (msRemaining <= 0) {
    return { expired: true, daysRemaining: -1 };
  }
  // Floor to whole days. Users see "3 days left" rather than "3.4 days left".
  return {
    expired: false,
    daysRemaining: Math.max(0, Math.floor(msRemaining / (1000 * 60 * 60 * 24))),
  };
}
